import {
    Legend,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip as ReChartsTooltip,
    ComposedChart,
    ResponsiveContainer, Area, AreaChart
} from 'recharts';
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import {
    bbDangerousStringToDate,
    bbErrorSection, bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory,
    bbTranslateBreachRiskScoreConfidenceLevelsToFidelityColor,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor
} from "../../../util/bbHelpers";
import React from "react";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Badge} from "reactstrap";
import {useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";
import BRFidelityBadge from "../BRPortfolio/BRFidelityBadge";
import EarlyAccessWrapper from "../settings/EarlyAccessWrapper";


function CustomTooltip({ payload, label, active }) {
    // console.log("tip payload is", payload)
    const safePayload = payload && Array.isArray(payload) && payload[0] ? payload[0].payload : {};
    // console.log("safePayload is", safePayload);
    if (active && safePayload) {
        // const isTheNeutralDataPoint = payload[0].payload.isTheNeutralDataPoint; //this data point is special

        return (
            <Widget styleName={`p-1 px-2`}>
                <h3><em>{`${bbFormattedDateString(label, "shortFullMonth")}`}</em></h3>
                {/*<h1 className="label">{ `BreachRisk™ Score: ${parseFloat(payload[0].value).toFixed(1)}`}</h1>*/}

                {/*<h4 className={"text-center"}>Risk Category:</h4>*/}


                {/*<Badge color={bbTranslateBreachRiskScoreToColor(parseFloat(payload[0].value).toFixed(1))}><span style={{fontSize: "larger"}}>{bbTranslateBreachRiskScoreToCategory(parseFloat(payload[0].value).toFixed(1))} Risk</span></Badge> }*/}
                {/*<hr/>*/}
                {/*<div>Threat Vectors Detected: {parseFloat(safePayload.vectors).toFixed(0)}</div> }*/}

                <div>Identities: {parseFloat(safePayload.identities).toFixed(0)}</div>
                {/*<div>Services: {parseFloat(safePayload.services).toFixed(0)}</div>*/}
                {/*<div>Active Hosts: {parseFloat(safePayload.targets).toFixed(0)}</div>*/}
                {/*<div>Subdomains: {parseFloat(safePayload.subdomains).toFixed(0)}</div>*/}
            </Widget>
        );
    }

    return null;
}

const bbTickFormatter = (input) => {
    return bbFormattedDateString(input, 'micro');
}

const RenderLineChart = (
    showVectorRiskScore = false,

    ) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError} = useSelector(({breachrisk}) => breachrisk);
    // const customer = customers ? customers[customerInView] : null;

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const hasEarlyAccess = EarlyAccessWrapper();

    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;

    let historyData = myEntity ? myEntity.history : null;
    const sortedHistoryData = historyData ? historyData.sort((a,b) => (bbDangerousStringToDate(a.cycle_date) > bbDangerousStringToDate(b.cycle_date) ? 1 : -1)) : null;

    //only show the 20 most recent data points
    const totalNumDataPoints = sortedHistoryData ? sortedHistoryData.length : null;
    const numDataPointsToShow = 20;
    if(totalNumDataPoints && totalNumDataPoints > numDataPointsToShow) {
        const numPointsToRemove = totalNumDataPoints - numDataPointsToShow;
        const removedHistoryData = sortedHistoryData.splice(0, numPointsToRemove);
    }

//TODO: split up the identities between stuff we detected automatically and those they told us about
    return <Widget styleName={`p-2 animated fadeIn animation-duration-5 dataTile`}>
        <Tooltip disableFocusListener

                 title={"The number of identities we've detected and you've added. The more identities hackers can detect, the easier social engineering attacks will be for them. Data in this chart can change based on our ability to detect identities on a given date, and also if you have added identities to ensure they have been tested."}>
            <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}
                           className={`text-muted`}/>
        </Tooltip>
        <div className="row"  id={"tourIdSocialHistory"}>
            <div className={"col-12"}>
                <h1 className={"text-center"}>Identities Trends</h1>
            </div>
        </div>
        <div className="row" style={{height: 250}}>
            <div className={"col-12"}>
                {!portfolios || loadingPortfolios[customerIdToUse] ?
                    <Skeleton count={10}/>
                    : !myEntity || loadingPortfoliosError[customerIdToUse] ?
                        <div className={"text-center"}>
                            {bbErrorSection("80px")}
                        </div>
                        :
                            <ResponsiveContainer>
                                <AreaChart width={800} height={400} data={sortedHistoryData}
                                               margin={{top: 1, right: 10, left: 2, bottom: 5}}>
                                    {/*<Area type="monotone" dataKey="confidence_upper" stroke="#999999" />*/}
                                    <defs>
                                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                            {/*//TODO:implement gradient colors based on the highest value*/}
                                            {/*<stop offset="0%" stopColor="#F6101F" stopOpacity={0.5}/>*/}
                                            {/*<stop offset="20%" stopColor="#F28722" stopOpacity={0.5}/>*/}
                                            {/*<stop offset="40%" stopColor="#EDEA34" stopOpacity={0.5}/>*/}
                                            {/*<stop offset="60%" stopColor="#5FBA15" stopOpacity={0.4}/>*/}
                                            {/*<stop offset="80%" stopColor="#00863B" stopOpacity={0.3}/>*/}
                                            {/*<stop offset="98%" stopColor="#00863B" stopOpacity={0.1}/>*/}

                                            <stop offset="5%" stopColor="#A6A6A6" stopOpacity={0.6}/>
                                            <stop offset="95%" stopColor="#A6A6A6" stopOpacity={0.1}/>
                                        </linearGradient>
                                    </defs>

                                    <Area type="monotone" name="Identities" dataKey="identities" stackId="1" stroke="#595959" fill="#595959" />
                                    {/*<Area type="monotone" name="Active Hosts" dataKey="targets" stackId="1" stroke="#A6A6A6" fill="#A6A6A6" />*/}
                                    {/*<Area type="monotone" name="Services" dataKey="services" stackId="1" stroke="#413c62" fill="#413c62" />*/}
                                    {/*<Area type="monotone" name="High-Risk Services" dataKey="services_high_risk" stackId="1" stroke="#F28722" fill="#F28722" />*/}




                                    {/*<Area type="monotone" dataKey="confidence_lower" stroke="#7784e8" />*/}
                                    {/*<CartesianGrid stroke="#ccc" strokeDasharray="5 5"/>*/}
                                    <ReChartsTooltip content={<CustomTooltip/>}/>
                                    <XAxis dataKey="cycle_date" tickFormatter={bbTickFormatter}/>
                                    <YAxis />
                                    <Legend verticalAlign={"bottom"}/>


                                </AreaChart>
                            </ResponsiveContainer>
                }
            </div>

        </div>

    </Widget>
};

export default RenderLineChart;